// extracted by mini-css-extract-plugin
export default {"box":"FancyBox_box__kB3Uk","box__icon":"FancyBox_box__icon__5XVVo","box__title":"FancyBox_box__title__-RGYb","box__text":"FancyBox_box__text__TyTQX"};